import React from 'react';
import { DoubleUpIcon, ExpandArrowDownIcon, ExpandArrowUpIcon } from '../icons/icons';

interface IProps {
    isCollapsed: boolean;
    isAllItemsCollapsed: boolean;
}

export const GroupCollapseIcon = (props: IProps) => {
    const { isCollapsed, isAllItemsCollapsed } = props;

    if (isCollapsed) {
        return <ExpandArrowDownIcon />;
    } else if (isAllItemsCollapsed) {
        return <DoubleUpIcon />;
    }
    return <ExpandArrowUpIcon />;
};
